import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StatusMessage = styled.div`
  color: ${colors.amber2};
  font-weight: 500;
  font-size: 13px;
  max-width: 300px;
  padding: 0 16px;
`;
